export default function language(state = 'pt', action) {
  switch (action.type) {
    case 'change_language': 
      return state = action.language;
    default:
      return state;
  }
}